/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function IncidentstmdLoadedReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeIncidentstmdLoadedAction } action: action
 *     de l'application
 * @return { Reducer }
 */
export const IncidentstmdLoadedReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeIncidentstmdLoadedAction) => {
      switch (action.type) {
        case actions.IncidentstmdLoadedActionTypes
            .INCIDENTSTMDLOADED_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.IncidentstmdLoadedActionTypes.INCIDENTSTMDLOADED_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.IncidentstmdLoadedActionTypes.INCIDENTSTMDLOADED_SUCCESS:

          return {
            data: action.payload.data, loading: false,
          }

          break;

        default:
          return state
          break;
      }
    }



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/lapi-tmd/incidents-tmd/index.ts